export default "__VITE_ASSET__9MaoFIRo__"